// import Coins from '@/views/coins/coins'
// import Earn from '@/views/coins/earn'

const Coins = r => require.ensure([], () => r(require('@/views/coins/coins')), '@/views/coins/..')
const Earn = r => require.ensure([], () => r(require('@/views/coins/earn')), '@/views/coins/..')
const Gold = r => require.ensure([], () => r(require('@/views/coins/gold')), '@/views/coins/..')

const GoldCoinMall = r => require.ensure([], () => r(require('@/views/coins/GoldCoinMall')), '@/views/coins/..')

export default [
    {
        path: '',
        component: GoldCoinMall,
        meta: {
            title: '金币商城'
        }
    },
    {
        path: 'myCoins',
        component: Coins,
        meta: {
            title: '我的金币'
        }
    },
    {
        path: 'earn',
        component: Earn,
        meta: {
            title: '如何赚取金币'
        }
    },
    {
        path: 'gold',
        component: Gold,
        meta: {
            title: '如何赚取金币'
        }
    },
    {
        path: 'oldEarn',
        component: Earn,
        meta: {
            title: '如何赚取金币'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/coins.js